export default __webpack_public_path__ + "static/media/Corner-Piece-P14-3-2mm.d97f8a4b.dwg";